<div class="d-flex flex-column align-items-center justify-content-center wrapper">
  <h1 class="display-1 fw-bold">404</h1>
  <p class="h1">
    <span class="text-capitalize">{{ resourceName }}</span> not found.
  </p>
  <p class="h2 fw-normal mt-3 mb-4">The {{ resourceName | lowercase }} you are looking for might have been removed.</p>
  <a *ngIf="backlink" class="btn btn-primary btn-lg" [routerLink]="backlink.path" role="button"> {{ backlink.label }} </a>
</div>
